import { applicationService } from '@/projects/admin/services/application-service';
import { t } from 'i18next';
import { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import DataGridWrapper from '@/core/wrappers/data-grid-wrapper';
import { RemoveMessage } from '@/core/helper/validation-rule-helper';
import CustomStore from 'devextreme/data/custom_store';
import { DataGrid } from 'devextreme-react/data-grid';
import { ROUTER_CONSTANTS } from '@/core/constants/common/router-constants';



const PermissionList = () => {
    const [store, setStore] = useState<CustomStore>();
    const dataGridRef = useRef<DataGrid>(null);
    useEffect(() => {
        setStore(new CustomStore({
            key: ['id'],
            load: applicationService.getPermissions,
            byKey: async (key, loadOptions: any) => {
                let returnObject = null;
                if (key) {
                    loadOptions.filter = ["id", "=", key];
                    const objectsByID = (await applicationService.getPermissions(loadOptions))
                    returnObject = objectsByID.data.length > 0 ? objectsByID.data[0] : null;
                }
                return returnObject
            },
            remove: applicationService.deletePermission,
            useDefaultSearch: true
        }));
    }, [])


    const navigate = useNavigate();
    const goToEdit = (id: string) => {
        navigate(`/admin/${ROUTER_CONSTANTS.ADMIN.Permissions}/${id}`, { state: { id: id } })
    }

    

    return (
        <div>
            <DataGridWrapper
                permissonCode='Admin.Application.Permission'
                datasource={store}
                pagerVisible={true}
                filterVisible={true}
                headerFilterVisible={true}
                enableCustomToolbarContent={true}
                navigateNewRecordPath={'/admin/'+ ROUTER_CONSTANTS.ADMIN.PermissionCreate}
                props={{ id: 'permission-list', ref: dataGridRef }}
                editingConfig={{
                    allowDeleting: true,
                    allowUpdating: true,
                    deleteMessageText: RemoveMessage('Account'),
                }}
                columns={[
                    { dataField: 'name', caption: t('permission'), allowFiltering: true, sortIndex: 0, sortOrder: "asc" },
                    { dataField: 'permissionCode', caption: t('permission_code'), allowFiltering: true },
                    { dataField: 'application', caption: t('application'), allowFiltering: true, sortIndex: 1, sortOrder: "asc"},
                    { dataField: 'description', caption: t('description'), allowFiltering: true, width: 200 }
                ]}
                buttonConfig={[
                    {
                        name: 'edit',
                        icon: 'edit',
                        onClick: function (e: any) {
                            goToEdit(e.row?.data.id);
                        },
                    },
                    {
                        name: 'delete',
                        icon: 'trash',
                    },
                ]}
            />
        </div>
    )
}
export default PermissionList